module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "survey-builder-dashboard"
    }
  }, [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header campaign-header"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h2', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("Survey Builder Dashboard")]), _vm._v(" "), _c('survey-filter', {
    staticClass: "pull-left",
    staticStyle: {
      "display": "inline"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [(_vm.surveyListLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading surveys"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.surveyListLoading && _vm.surveyList && !_vm.surveyList.length) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.surveyListLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._l((_vm.surveyList), function(survey) {
    return _c('survey-list-item', {
      key: survey.id,
      attrs: {
        "id": parseInt(survey.id, 10),
        "title": survey.title,
        "state": _vm.determineSurveyState(survey),
        "growth": survey.growth,
        "totalEntries": survey.totalEntries,
        "totalThisMonth": survey.totalEntriesThisMonth,
        "totalPerDayThisMonth": survey.totalPerDayThisMonth,
        "progress": _vm.calculateProgress(survey),
        "isSpotSurvey": survey.isSpot,
        "favorite": survey.favorite,
        "isPreview": survey.isPreview,
        "startDate": _vm.moment(survey.startDate),
        "endDate": _vm.moment(survey.endDate),
        "createdBy": survey.createdBy,
        "editable": true,
        "isAdminUser": _vm.me.is_staff
      },
      on: {
        "onDownloadMessages": function($event) {
          return _vm.handleDownloadMessages(survey)
        },
        "onEditSurvey": function($event) {
          return _vm.handleEditSurvey(survey)
        },
        "onViewSurvey": function($event) {
          return _vm.handleViewSurvey(survey)
        },
        "onToggleActiveStatus": function($event) {
          return _vm.handleToggleLiveStatus($event, survey.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.surveyList.length == 0) ? _c('empty', [_vm._v("No surveys found.")]) : _vm._e(), _vm._v(" "), (_vm.surveyListTotalPages > 1) ? _c('div', {
    staticClass: "text-center"
  }, [(_vm.surveyList.length) ? _c('paginator', {
    attrs: {
      "id": "paginator",
      "pages": _vm.surveyListTotalPages,
      "currentPage": _vm.surveyListPage
    },
    on: {
      "goToNextPage": _vm.handleNextPage,
      "goToPreviousPage": _vm.handlePreviousPage,
      "goToPage": _vm.handleGoToPage
    }
  }) : _vm._e()], 1) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), _c('fab-speed-dial', {
    attrs: {
      "position-type": "fixed",
      "icon-size": "small",
      "mainTooltip": "New Survey"
    },
    on: {
      "click": _vm.handleCreateSurvey
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "empty"
  }, [_vm._v("No surveys found within the current filter.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c9e9443","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/SurveyBuilderDashboard.vue
// module id = 3194
// module chunks = 3